'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.monthly_active_report', {
        template: '<monthly-active-report></monthly-active-report>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/active_report/monthly/monthly_active_report.routes.js